<template>
  <div class="lst-header">
    <header class="keep-header">
      <div class="phone-download-warp">
         <div class="phone-slogn">
              <img src="@/assets/images/phoneSlogn.png" />
            </div>
        <div class="phone-download">
          <a class="phone-link" href="https://apps.apple.com/in/app/id1481691002">
            <img src="@/assets/images/phoneIos.png" alt />
          </a>
          <a class="phone-link" href="https://android.myapp.com/myapp/detail.htm?apkName=com.lushangtong.app&ADTAG=mobile">
            <img src="@/assets/images/phoneAndroid.png" alt />
          </a>
          <a class="phone-link" @click="downloadlsshApp">
            <img src="@/assets/images/lsshdownload.png" alt />
          </a>
        </div>
        <p class="footerTitle">鲁商集团国企担当</p>
      </div>
      <div class="out-container" :style="{height:clientHeight+'px',width:clientWidth+'px'}">
        <div class="inner-container">
          <div class="video-wrap" :style="{height:clientHeight+'px',width:clientWidth+'px'}">
            <div :style="{width:'100%',height:'100%'}">
              <!-- <video id="video-bg" src="http://lstagt.lushang.com.cn:8056/imageServer/video/5s.mp4" muted autoplay loop preload='auto'  ></video> -->
            </div>
            <div class="video-control">
              <img src="@/assets/images/slogan.png" />
            </div>
            <div class="video-bottom">
              <div class="bottom-container">
                <p class="bottom-pull">滑动发现更多</p>
                <div class="bottom-center">
                  
                  <div class="columnLine"></div>
                </div>
                <div class="bottom-right">
                  <a href="#" class="qrcode">
                    <span class="appledownload"></span>
                    <img src="@/assets/images/oneCode.png" class="qrcode" alt />
                  </a>
                  <a href="#" class="qrcode">
                    <span class="androiddownload"></span>
                    <img src="@/assets/images/twoCode.png" class="qrcode" alt />
                  </a>
                  <a href="#" class="qrcode">
                    <span class="lsshdownload"></span>
                    <img src="@/assets/images/lssh_qrcode.jpg" class="qrcode" alt />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="video-wrap" :style="{height:clientHeight+'px'}" >
        <div :style="{width:'100%',height:'100%'}">
          <video id="video-bg" src="@/assets/mp4/5s.mp4" muted autoplay loop></video>
        </div>
        <div class="video-control">
          <img src="@/assets/images/slogan.png" />
        </div>
        <div class="video-bottom">
          <div class="bottom-right">
            <a href="#" class="qrcode">
              <span class="appledownload"></span>
              <img src="@/assets/images/oneCode.png"  class="qrcode" alt />
            </a>
            <a href="#" class="qrcode">
              <span class="androiddownload"></span>
              <img src="@/assets/images/twoCode.png"  class="qrcode" alt />
            </a>
          </div>
        </div>
      </div>-->
    </header>
    <div class="filling"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientWidth: window.innerWidth,
      clientHeight: window.innerHeight,
    };
  },
  methods:{
    downloadlsshApp(){
      alert("请在PC端使用微信扫码打开")
    }
  }
};
</script>

<style lang="scss" scoped>
.lst-header::-webkit-scrollbar {
  display: none;
}
.keep-header {
  width: 100%;
}

.phone-download {
  text-align: center;
  padding: 17% 0 18%;

  .phone-link {
    display: block;
    width: 155px;
    margin: 26px auto 0;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.phone-download-warp {
  display: none;
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/head-1.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.video-bottom {
  width: 100%;
  
  .bottom-container {
    width: 1200px;
    margin: 0 auto;
    .bottom-pull{
    text-align: center;
    margin-bottom: 60px;
    font-size: 24px;
    color: #ffff;
    letter-spacing: 5px;
  }
    .bottom-center {
      // text-align: center;
      // position: absolute;
      // left: 40%;
      // bottom: 0;
      height: 75px;
      background-color: #fd5a01;
      opacity: 1;
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 2;
      width: 1px;
      // margin-left: -0.5px;
      .columnLine {
        animation: k-link 2s linear -0.5s infinite normal;
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        transform: scaleY(0);
        transform-origin: 0 0
      }
    }
    .bottom-right {
      // width: 1200px;
      // margin:  0 auto;
    }
  }
}
.phone-slogn{
  width: 80%;
  margin-left: 10%;
  img{
    width: 100%;
    margin-top: 50%;
  }
}
.footerTitle{
  text-align: center;
  color: #ffffff;
  margin-top: 34%;
}
@media (max-width: 767.98px) {
  .keep-header{
    height: 100%;
  }
  .phone-download-warp {
    display: block;
  }

  .video-wrap {
    display: none;
  }
  .video-control {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background: rgba(34, 34, 34, 0.8);
      background: url("../assets/images/vediobg1.png") no-repeat center;
      #video-play {
        display: none;
      }
    }
}
@media (min-width: 768px) {
  .keep-header {
    position: fixed;
    width: 100%;
    height: calc(49.6vw);
    left: 0;
    top: 0;
  }
  .video-wrap {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .video-control {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background: rgba(34, 34, 34, 0.8);
      background: url("../assets/images/vediobg1.png") no-repeat center;
      #video-play {
        display: none;
      }
    }

    .video-bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;
      line-height: 1;
      .bottom-right {
        // margin-right: 35px;
        // width: 1200;
        // margin: 0 auto;

        a + a {
          margin-left: 30px;
        }

        a > img {
          width: 160px;
        }

        a.qrcode {
          display: none;
        }
      }
    }
  }
  .gameConsUl::-webkit-scrollbar {
    display: none !important;
  }
  #video-bg {
    // width: 100%;
    margin-top: -42px;
    object-fit: contain;
  }

  .filling {
    height: calc(49.6vw);
  }
}

@media (min-width: 1024px) {
  .video-wrap .video-control #video-play {
    display: block;
    cursor: pointer;
  }

  .bottom-right {
    display: flex;
    align-items: center;
    // width: 1200px;
    // margin: 0 auto;
    margin-bottom: 30px;
    justify-content: flex-end;
    margin-right: 40px;
    a.qrcode {
      display: inline-flex !important;
      justify-content: center;
      align-items: center;
      text-align: center;
      position: relative;
      background: transparent;
      border-radius: 5px 5px;
      span {
        display: inline-block;
        width: 130px;
        height: 42px;
        background-size: contain;
        color: #fff;
      }
      .appledownload {
        background: url("../assets/images/appledownload.png") no-repeat center
          center;
      }
      .androiddownload {
        background: url("../assets/images/androiddownload.png") no-repeat center
          center;
      }
      .lsshdownload{
        background: url("../assets/images/lsshdownload.png") no-repeat center
          center;
      }
      &:hover {
        img.qrcode {
          display: block;
        }
      }
    }
    img.qrcode {
      display: none;
      position: absolute;
      right: 0;
      bottom: 60px;
    }
  }
}
.footer {
}
</style>
<style>
@keyframes k-link {
  0% {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
  25% {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}
@-webkit-keyframes k-link {
  0% {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
  25% {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}
</style>